package com.macrofocus.eflux.data.quest

import com.macrofocus.common.units.ApparentPower
import com.macrofocus.common.units.PerUnit
import com.macrofocus.common.units.Quantity
import com.macrofocus.common.units.into
import com.macrofocus.eflux.data.BranchPowerFlowRecord
import org.molap.dataframe.DataFrame

class QuestBranchPowerFlowRecord(private val dataFrame: DataFrame<Int, String, Any?>, private val row: Int) : BranchPowerFlowRecord {
    override val datetime: Any
        get() = dataFrame.getValueAt(row, "datetime") as Any
    override val i: String
        get() = dataFrame.getValueAt(row, "from") as String
    override val j: String
        get() = dataFrame.getValueAt(row, "to") as String
    override val ckt: String
        get() = (dataFrame.getValueAt(row, "ckt") as String).trim('\'').trim()
    override val r: Quantity<PerUnit>
        get() = (dataFrame.getValueAt(row, "r") as Double).into(PerUnit.pu)
    override val x: Quantity<PerUnit>
        get() =(dataFrame.getValueAt(row, "x") as Double).into(PerUnit.pu)
    override val b: Quantity<PerUnit>
        get() = (dataFrame.getValueAt(row, "b") as Double).into(PerUnit.pu)
    override val ratea: Quantity<ApparentPower>
        get() = (dataFrame.getValueAt(row, "ratea") as Double).into(ApparentPower.MegavoltAmpere)
    override val rateb: Quantity<ApparentPower>
        get() = (dataFrame.getValueAt(row, "rateb") as Double).into(ApparentPower.MegavoltAmpere)
    override val ratec: Quantity<ApparentPower>
        get() = (dataFrame.getValueAt(row, "ratec") as Double).into(ApparentPower.MegavoltAmpere)
    override val gi: Quantity<PerUnit>
        get() = (dataFrame.getValueAt(row, "gi") as Double).into(PerUnit.pu)
    override val bi: Quantity<PerUnit>
        get() = (dataFrame.getValueAt(row, "bi") as Double).into(PerUnit.pu)
    override val gj: Quantity<PerUnit>
        get() = (dataFrame.getValueAt(row, "gj") as Double).into(PerUnit.pu)
    override val bj: Quantity<PerUnit>
        get() = (dataFrame.getValueAt(row, "bj") as Double).into(PerUnit.pu)
    override val st: Int
        get() = (dataFrame.getValueAt(row, "st") as Number).toInt()
    override val met: Int
        get() = (dataFrame.getValueAt(row, "met") as Number).toInt()
    override val len: Double
        get() = dataFrame.getValueAt(row, "len") as Double
    override val o1: Double
        get() = dataFrame.getValueAt(row, "o1") as Double
    override val f1: Double
        get() = dataFrame.getValueAt(row, "f1") as Double
}